<template>
  <v-dialog :value="open" width="500" persistent>
    <v-card>
      <v-card-title>{{ $t('app.serviceWorkerNotSupportedHeadline') }}</v-card-title>
      <v-card-text> {{ $t('app.serviceWorkerNotSupportedText') }} </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ServiceWorkerNotSupported',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style></style>
